if (
  typeof Number !== undefined
  && Number.prototype
  && !Number.prototype.humanizeTimestamp
) {
  Object.defineProperty(Number.prototype, 'humanizeTimestamp', {
    value({
      includeMilliseconds = false,
      includeHours = false,
      includeHundrethsPlace = false
    } = {}) {
      let string = new Date(this * 1000).toISOString();
      if (
        includeHours ||
        (
          includeHours !== false &&
          this >= 3600
        )
      ) {
        string = string.substr(11, includeHundrethsPlace ? 12 : 11);
      } else {
        string = string.substr(14, includeHundrethsPlace ? 9 : 8);
      }
      const timestamp = (includeMilliseconds) ? string : string.split('.')[0];
      const split = timestamp.split(':');
      let hours;
      let minutes;
      let seconds;
      let milliseconds;
      if (split.length === 3) {
        hours = parseInt(split[0]);
        minutes = parseInt(split[1]);
        seconds = split[2];
      } else {
        minutes = parseInt(split[0]);
        seconds = split[1];
      }
      let ms_split = seconds.split('.');
      seconds = parseInt(ms_split[0]);
      if (ms_split.length > 1) milliseconds = parseInt(ms_split[1]);
      if (typeof milliseconds === 'number' && !/^[0-9]{3}$/.test(milliseconds)) milliseconds = milliseconds * 10;
      let arr = []
      if (includeHours && hours) arr.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
      if (minutes) arr.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
      if (seconds) arr.push(`${seconds} ${seconds === 1 ? 'second' : 'seconds'}`);
      if (milliseconds && includeMilliseconds) arr.push(`${milliseconds} ${milliseconds === 1 ? 'millisecond' : 'milliseconds'}`);
      return arr.join(', ').trim().length ? arr.join(', ') : '0 seconds';
    }
  });
}